import { render, staticRenderFns } from "./requisition-details.vue?vue&type=template&id=75008ba1&scoped=true&"
import script from "./requisition-details.vue?vue&type=script&lang=js&"
export * from "./requisition-details.vue?vue&type=script&lang=js&"
import style0 from "./requisition-details.vue?vue&type=style&index=0&id=75008ba1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75008ba1",
  null
  
)

export default component.exports